export const CENTRAL_POT_VALUE = '__central_pot__';
export const OTHER_VALUE = '__other__';

interface PayerInput {
  paidBy: string;
  /** The paid_by the payment was loaded with; a name no longer in any list stays selectable. */
  legacyPaidBy: string;
  couple: string[];
  contributors: string[];
}

export interface PayerSelect {
  selectValue: string;
  isCentralPot: boolean;
  isOther: boolean;
  /** A saved payer that is not a honoree or contributor now: shown as its own option so nothing is lost. */
  pinned: string | null;
}

/** Which "Paid by" option is selected, without flipping saved names to free text while the lists load. */
export function resolvePayerSelect({ paidBy, legacyPaidBy, couple, contributors }: PayerInput): PayerSelect {
  const isCentralPot = paidBy === CENTRAL_POT_VALUE || paidBy === 'Central Pot';
  const known = [...couple, ...contributors].includes(paidBy);
  const pinned = !isCentralPot && paidBy !== '' && !known && paidBy === legacyPaidBy ? paidBy : null;
  const isOther = paidBy !== '' && !isCentralPot && !known && pinned === null;
  const selectValue = isCentralPot ? CENTRAL_POT_VALUE : isOther ? OTHER_VALUE : paidBy;
  return { selectValue, isCentralPot, isOther, pinned };
}
